export default __webpack_public_path__ + "static/media/product03-1-480x360.419e506b.jpg";